export default __webpack_public_path__ + "static/media/Newsletter 015.fc23eff9.png";